import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { SafetyOutlined } from '@ant-design/icons';
import { SonarMenuItem } from '@ui/menu';

import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';

export const dataSecuritySubMenu: SonarMenuItem = {
	children: [
		{
			feature: FeatureFlag.AccessAudit,
			id: 'data-access-menu-item',
			key: FULL_ROUTES.DATA_SECURITY_DATA_ACCESS,
			label: COPY_SPECIFIC.DATA_ACCESS,
			route: FULL_ROUTES.DATA_SECURITY_DATA_ACCESS
		}
	],
	icon: <SafetyOutlined />,
	id: 'data-security-submenu',
	key: 'data-security',
	label: COPY_SPECIFIC.DATA_SECURITY
};
